export default __webpack_public_path__ + "static/undraw_startled-45c537ebe0265a2dd165a3308272a767.svg";